/**
 * What to call the Ctrl/⌘ modifier in a shortcut hint on this platform.
 *
 * Only the wording: every handler taking this chord tests `ctrlKey || metaKey` and declares both in
 * `aria-keyshortcuts`, so the platform decides what a hint says and never what the key does.
 *
 * Read once at module scope — the platform cannot change, and re-reading it per render would be
 * work for a string that never moves. Anything that is not an Apple platform, jsdom included, gets
 * Ctrl, which is the honest answer for a machine whose keyboard has no ⌘.
 */
export const PRIMARY_MODIFIER_LABEL =
	typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent)
		? 'Cmd'
		: 'Ctrl';
